import type { ErrorMap } from '@/app/error-registry';

export const CUSTOM_FIELDS_ERROR_MAP: ErrorMap = {
  POST: {
    'ProjectField.NameAlreadyExists': 'customFields:apiErrors.nameAlreadyExists',
    'ProjectField.InvalidType': 'customFields:apiErrors.invalidType',
    default: 'customFields:apiErrors.createDefault',
  },
  PUT: {
    'ProjectField.NotFound': 'customFields:apiErrors.notFound',
    'ProjectField.NameAlreadyExists': 'customFields:apiErrors.nameAlreadyExists',
    'ProjectFieldOption.NotFound': 'customFields:apiErrors.optionNotFound',
    'ProjectFieldOption.NameTooLong': 'customFields:apiErrors.optionNameTooLong',
    'ProjectFieldOption.ValueTooLong': 'customFields:apiErrors.optionValueTooLong',
    default: 'customFields:apiErrors.updateDefault',
  },
  DELETE: {
    'ProjectField.NotFound': 'customFields:apiErrors.notFound',
    'ProjectField.InUse': 'customFields:apiErrors.inUse',
    'ProjectFieldOption.NotFound': 'customFields:apiErrors.optionNotFound',
    default: 'customFields:apiErrors.deleteDefault',
  },
};
